export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10535.0739437e.jpg";